import { type ReactNode } from 'react';
import { TextInput } from '@mantine/core';
import type { TextInputProps } from '@mantine/core';
import './Input.css';

export interface InputProps extends Omit<TextInputProps, 'leftSection' | 'rightSection'> {
    leftAddon?: ReactNode;
    rightAddon?: ReactNode;
    error?: ReactNode | boolean;
}

export default function Input({
    leftAddon,
    rightAddon,
    error,
    className = '',
    ...props
}: InputProps) {
    return (
        <TextInput
            className={`custom-input ${className}`.trim()}
            leftSection={leftAddon}
            rightSection={rightAddon}
            error={error}
            {...props}
        />
    );
}

